export const isSuccess = (resp) => {
  if (resp && resp.code === 'SUCCESS') {
    return true
  }
  return false
}

/**
 * @param prefix 唯一ID前缀
 * @returns
 */
export const uuid = (prefix = '') => prefix + Math.random().toString(36).slice(-8)
